/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./update-assign-dialog.vue?vue&type=template&id=6c29a0d8&"
import script from "./update-assign-dialog.vue?vue&type=script&lang=js&"
export * from "./update-assign-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports